import { Plugin } from '@nuxt/types';
import Splitter from './SplitterClient';

const SplitterPlugin: Plugin = (_context, inject) => {
  inject('splitter', Splitter);
};

export default SplitterPlugin;
